type DashboardLocale = typeof import('../en/dashboard').default

const dashboard = {
	title: 'Panel',
	subtitle: 'Tu panel personal',
	collections: {
		title: '{{collectionEntityLabelPlural}}',
		subtitle:
			'{{collectionEntityLabelPlural}} de aprendizaje y colecciones de {{mainEntityLabelPluralLower}}',
	},
	courses: {
		title: '{{mainEntityLabelPlural}}',
		subtitle: 'Inscripciones a {{mainEntityLabelPluralLower}}',
		columns: {
			title: 'Título {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
			instructor: 'Instructor',
			level: 'Nivel',
			progress: 'Progreso',
			lastAccessed: 'Último acceso',
			enrollmentDate: 'Inscrito',
			actions: 'Acciones',
		},
		empty: {
			title: 'No se encontraron {{mainEntityLabelPluralLower}}',
			description:
				'Aún no tienes inscripciones a {{mainEntityLabelPluralLower}}.',
		},
	},
	templates: {
		title: 'Plantillas de {{mainEntityLabelPluralLower}}',
		subtitle:
			'Plantillas de {{mainEntityLabelPluralLower}} disponibles para crear instancias',
		columns: {
			title: 'Título de la plantilla',
			category: 'Categoría',
			level: 'Nivel',
			instances: 'Instancias',
			published: 'Publicado',
			lastModified: 'Última modificación',
			actions: 'Acciones',
		},
		empty: {
			title: 'No se encontraron plantillas',
			description:
				'No hay plantillas de {{mainEntityLabelPluralLower}} disponibles.',
		},
	},
	instances: {
		title: 'Instancias de {{mainEntityLabelPluralLower}}',
		subtitle: 'Instancias activas de {{mainEntityLabelPluralLower}}',
		columns: {
			title: 'Título de la instancia',
			template: 'Plantilla',
			owner: 'Propietario',
			progress: 'Progreso',
			createdDate: 'Creado',
			lastAccessed: 'Último acceso',
			actions: 'Acciones',
		},
		empty: {
			title: 'No se encontraron instancias',
			description:
				'No hay instancias de {{mainEntityLabelPluralLower}} disponibles.',
		},
	},
	topics: {
		title: 'Temas',
		subtitle: 'Temas de tus {{mainEntityLabelPluralLower}}',
		columns: {
			title: 'Título del tema',
			course: '{{mainEntityLabel}}',
			module: 'Módulo',
			progress: 'Progreso',
			bookmarked: 'Marcado',
			lastAccessed: 'Último acceso',
			actions: 'Acciones',
		},
		empty: {
			title: 'No se encontraron temas',
			description: 'No hay temas disponibles.',
		},
	},
} satisfies DashboardLocale

export default dashboard
